// src/pages/health/PainExerciseGuide/data/videos.js
export const VIDEOS_BY_ITEM = {
    "neck_scalene": [
        {
            "id": "Static/Static-S-0004",
            "title": "사각근 자가근막이완-공(Scalene Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/Static-S-0004.png",
            "guide": [
                "테니스공 또는 마사지볼을 이용하여 사각근을 30초~1분 내외로 마사지한다.",
                "양쪽 모두 실시하고 3회씩 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0005",
            "title": "전사각근 스트레치(Anterior Scalene stretch)",
            "thumb": "/assets/thumbs/Stretch-0005.png",
            "guide": [
                "목을 한 쪽으로 기울이고(측굴) 반대방향 위쪽으로 가볍게 회전(상방회전)하여 10초간 유지한다.",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0006",
            "title": "후사각근 스트레치(Posterior Scalene stretch)",
            "thumb": "/assets/thumbs/Stretch-0006.png",
            "guide": [
                "목을 한 쪽으로 기울이고(측굴) 같은 방향 아래쪽으로 가볍게 회전(하방회전)하여 10초간 유지한다.",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
    ],
    "neck_levator": [
        {
            "id": "TP/TP-0020",
            "title": "견갑거근 자가근막이완-공(Levator scapulae Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/TP-0020.png",
            "guide": [
                "벽에 기대 마사지볼을 한 쪽 견갑거근(견갑골 상각부에서 목쪽)에 두고 고개를 반대쪽으로 측굴한 후 앞으로 기울인다.",
                "30초~1분간 유지하여 3~5회 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "TP/TP-0021",
            "title": "견갑거근 자가근막이완-쎄라케인(Levator scapulae Self Myofascial Release, theracane)",
            "thumb": "/assets/thumbs/TP-0021.png",
            "guide": [
                "목을 한 쪽 측면으로 기울이고 아래로 숙여 같은 방향으로 회전한다.",
                "근육이완 도구(쎄라케인)를 이용해 견갑거근 위치에 두고 3~5초간 압박이완 한다.",
                "5~10회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0007",
            "title": "견갑거근 스트레치(Levator Scapulae stretch)",
            "thumb": "/assets/thumbs/Stretch-0007.png",
            "guide": [
                "목을 옆으로 굽히고(측굴) 앞으로 숙인 후 안쪽으로 살짝 회전하여 15초간 유지한다.",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
    ],

    "neck_subscap": [
        {
            "id": "TP/TP-0045",
            "title": "견갑하근 자가근막이완-공(Subscapularis self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0045.png",
            "guide": [
                "옆으로 누워 아래쪽 팔을 위로 뻗어 가슴과 겨드랑이 사이에 마사지볼을 둔다.",
                "볼에 체중을 실어 30초간 압박하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0046",
            "title": "견갑하근 자가근막이완-셀프마사지(Subscapularis self myofascial release)",
            "thumb": "/assets/thumbs/TP-0046.png",
            "guide": [
                "팔을 위로 올려 반대쪽 손으로 가슴과 겨드랑이 사이를 압박한다.",
                "30초간 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0073",
            "title": "견갑하근 스트레치(Subscapularis stretch)",
            "thumb": "/assets/thumbs/Stretch-0073.png",
            "guide": [
                "오른팔을 어깨높이에 맞춰 옆으로 들어 팔꿈치를 굽히고 전완(팔꿈치 아래)을 세운다.",
                "오른쪽 어깨가 외회전된 상태로 바(Bar)를 잡고, 왼손으로 바의 아래쪽을 잡는다.",
                "왼손으로 바를 앞쪽으로 당겨 오른쪽 어깨가 더 외회전 되도록하여 10~15초간 유지한다.",
                "원위치로 돌아와 팔을 바꿔 실시하고, 3세트 반복한다."
            ]
        },
    ],

    "neck_cervical": [
        {
            "id": "TP/TP-0006",
            "title": "경판상근 자가근막이완-공(Splenius self myofascial release-ball)",
            "thumb": "/assets/thumbs/TP-0006.png",
            "guide": [
                "마사지볼을 후두골 아래쪽(경판상근)에 두고 손으로 압박하면서 마사지한다.",
                "30초~1분간 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0008",
            "title": "경판상근 자가근막이완-쎄라케인(Splenius self myofascial release-theracane)",
            "thumb": "/assets/thumbs/TP-0008(splenius).png",
            "guide": [
                "쎄라케인(마사지스틱)을 후두골 아래쪽(경판상근)에 두고 손으로 잡아당겨 압박한다.",
                "30초~1분간 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0007(splenius)",
            "title": "경판상근 스트레치(Splenius stretch)",
            "thumb": "/assets/thumbs/Stretch-0007(splenius).png",
            "guide": [
                "척추를 바로 세우고 왼팔을 머리 위로 보내 손을 오른쪽 측두골에 댄다.",
                "목을 왼쪽으로 기울여(측굴) 앞으로 숙인 후 겨드랑이쪽으로 가볍게 회전한다.",
                "손으로 가볍게 밀면서 15초간 유지한 후 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
    ],

    "neck_trap": [
        {
            "id": "FR/FR-0003",
            "title": "흉추신전운동-폼롤러(Thoracic Extension exercise, foam roller)",
            "thumb": "/assets/thumbs/FR-0003.png",
            "guide": [
                "등에 폼롤러를 가로로 두고 누워 엉덩이를 들고, 양 팔을 가슴앞으로 팔짱을 끼거나 목 뒤로 깎지를 낀다.",
                "다리로 지지하고 가슴을 펴서 폼롤러를 위아래로 굴린다.",
                "30초~1분간 3~5회 반복한다."
            ]
        },
        {
            "id": "Static/Static-P-0004",
            "title": "승모근 자가근막이완-공(Trapezisus Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/Static-P-0004.png",
            "guide": [
                "마사지볼을 한 쪽 승모근 기시부에 두고 벽에 기대 고개를 반대쪽으로 기울여(측굴) 30초~1분간 유지한다.",
                "3~5회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "TP/TP-0018",
            "title": "승모근 자가근막이완-쎄라케인(Trapezius Self Myofascial Release, theracane)",
            "thumb": "/assets/thumbs/TP-0018.png",
            "guide": [
                "목을 한 쪽 방향으로 기울이고 근육이완 도구(쎄라케인)를 반대방향 승모근 위치에 두고 3~5초간 압박이완 한다.",
                "5~10회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0003",
            "title": "승모근 스트레치-목 측굴(Trapezius stretch, Neck side flexion)",
            "thumb": "/assets/thumbs/Stretch-0003.png",
            "guide": [
                "척추를 바로 세우고 앉거나 서서 목을 옆으로 굽혀서 15초간 유지한다.",
                "양쪽 모두 실시하고 3회씩 반복한다."
            ]
        },
    ],

    "neck_suboccip": [
        {
            "id": "FR/FR-0001",
            "title": "후두하근 자가근막이완-폼롤러(Suboccipital Muscle Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0001.png",
            "guide": [
                "뒷목덜미에 폼롤러를 가로로 두고 바로 누워 목을 천천히 좌우로 회전한다.(10회 3세트 반복)"
            ]
        },
        {
            "id": "Static/Static-S-0003",
            "title": "후두하근 자가근막이완-공(Suboccipital muscle Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/Static-S-0003.png",
            "guide": [
                "땅콩볼을 후두부에 두고 바로 누워 후두하근을 30초~1분 이내로 압박이완 한다.(3회 반복)"
            ]
        },
        {
            "id": "Stretch/Stretch-0008",
            "title": "수건을 이용한 후두하근 스트레치(Suboccipital muscle stretch with towel)",
            "thumb": "/assets/thumbs/Stretch-0008.png",
            "guide": [
                "척추를 바르게 세우고 앉아 수건을 목 뒤 후두부에 턱을 살짝 들어올린다.",
                "손으로 수건 양 끝을 잡아 위쪽으로 10초간 당긴다.(3회 반복)"
            ]
        },
    ],

    "neck_scm": [
        {
            "id": "TP/TP-0001",
            "title": "흉쇄유돌근 자가근막이완-공(SCM Self Myofascial Release, Ball)",
            "thumb": "/assets/thumbs/TP-0001.png",
            "guide": [
                "마사지볼을 흉쇄유돌근에 두고 가볍게 압박하면서 공을 굴려 마사지한다.",
                "30초~1분간 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0002",
            "title": "흉쇄유돌근 스트레치-목 신전(SCM stretch, Neck extension)",
            "thumb": "/assets/thumbs/Stretch-0002.png",
            "guide": [
                "척추를 바로 세우고 앉아 목을 뒤로 젖히고 10~15초간 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0003",
            "title": "흉추신전운동-폼롤러(Thoracic Extension exercise, foam roller)",
            "thumb": "/assets/thumbs/FR-0003.png",
            "guide": [
                "등에 폼롤러를 가로로 두고 누워 엉덩이를 들고, 양 팔을 가슴앞으로 팔짱을 끼거나 목 뒤로 깎지를 낀다.",
                "다리로 지지하고 가슴을 펴서 폼롤러를 위아래로 굴린다.",
                "30초~1분간 3~5회 반복한다."
            ]
        },
    ],
    "neck_semispinalis": [
        {
            "id": "FR/FR-0001",
            "title": "후두하근 자가근막이완-폼롤러(Suboccipital Muscle Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0001.png",
            "guide": [
                "뒷목덜미에 폼롤러를 가로로 두고 바로 누워 목을 천천히 좌우로 회전한다.(10회 3세트 반복)"
            ]
        },
        {
            "id": "Static/Static-F-0003",
            "title": "오른쪽 후경부근육 자가근막이완-공(Right Posterior Cervical Muscle Self Myofascial Release, Ball)",
            "thumb": "/assets/thumbs/Static-F-0003.png",
            "guide": [
                "테니스공 또는 마사지볼을 이용하여 오른쪽 경판상근, 경반극근을 30초~1분 이내로 마사지한다.(3회 반복)"
            ]
        },
        {
            "id": "Stretch/Stretch-0001",
            "title": "후경부근육 스트레치-목 굴곡(Posterior Cervical Muscle stretch, Neck flexion)",
            "thumb": "/assets/thumbs/Stretch-0001.png",
            "guide": [
                "척추를 바로 세우고 앉거나 서서 목을 앞으로 굽혀 약 10초 유지한다.(3회 반복)"
            ]
        },
    ],
    "neck_splenius": [
        {
            "id": "FR/FR-0001",
            "title": "후두하근 자가근막이완-폼롤러(Suboccipital Muscle Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0001.png",
            "guide": [
                "뒷목덜미에 폼롤러를 가로로 두고 바로 누워 목을 천천히 좌우로 회전한다.(10회 3세트 반복)"
            ]
        },
        {
            "id": "Static/Static-S-0003",
            "title": "후두하근 자가근막이완-공(Suboccipital muscle Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/Static-S-0003.png",
            "guide": [
                "땅콩볼을 후두부에 두고 바로 누워 후두하근을 30초~1분 이내로 압박이완 한다.(3회 반복)"
            ]
        },
        {
            "id": "Stretch/Stretch-0008",
            "title": "수건을 이용한 후두하근 스트레치(Suboccipital muscle stretch with towel)",
            "thumb": "/assets/thumbs/Stretch-0008.png",
            "guide": [
                "척추를 바르게 세우고 앉아 수건을 목 뒤 후두부에 턱을 살짝 들어올린다.",
                "손으로 수건 양 끝을 잡아 위쪽으로 10초간 당긴다.(3회 반복)"
            ]
        },
        {
            "id": "Stretch/Stretch-0001",
            "title": "후경부근육 스트레치-목 굴곡(Posterior Cervical Muscle stretch, Neck flexion)",
            "thumb": "/assets/thumbs/Stretch-0001.png",
            "guide": [
                "척추를 바로 세우고 앉거나 서서 목을 앞으로 굽혀 약 10초 유지한다.(3회 반복)"
            ]
        },
    ],
    "neck_trap_lower": [
        {
            "id": "Static/Static-P-0006",
            "title": "하부승모근 자가근막이완-공(Lower Trapezius Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/Static-P-0006.png",
            "guide": [
                "테니스공 또는 마사지볼을 한 쪽 견갑골 아래에 두고 벽에 기대 뒤로 밀면서 30초~1분간 유지한다.",
                "3~5회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0021",
            "title": "하부승모근 스트레치(Lower trapezius stretch)",
            "thumb": "/assets/thumbs/Stretch-0021.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "엉덩이를 뒤로 보내고 상체를 아래로 내려 15초간 유지하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Static/Static-F-0134",
            "title": "왼쪽 하부승모근 스트레치(Left Lower trapezius stretch)",
            "thumb": "/assets/thumbs/Static-F-0134.png",
            "guide": [
                "왼손을 145°로 뻗어(어깨굴곡 145°) 벽에 기대서 15초간 유지한다.(3회 반복)"
            ]
        },
        {
            "id": "Static/Static-F-0102",
            "title": "오른쪽 하부승모근 스트레치(Right Lower Trapezius stretch)",
            "thumb": "/assets/thumbs/Static-F-0102.png",
            "guide": [
                "오른손을 145°로 뻗어(어깨굴곡 145°) 벽에 기대고 15초간 유지한다.(3회 반복)"
            ]
        },
    ],
    "neck_trap_upper": [
        {
            "id": "FR/FR-0003",
            "title": "흉추신전운동-폼롤러(Thoracic Extension exercise, foam roller)",
            "thumb": "/assets/thumbs/FR-0003.png",
            "guide": [
                "등에 폼롤러를 가로로 두고 누워 엉덩이를 들고, 양 팔을 가슴앞으로 팔짱을 끼거나 목 뒤로 깎지를 낀다.",
                "다리로 지지하고 가슴을 펴서 폼롤러를 위아래로 굴린다.",
                "30초~1분간 3~5회 반복한다."
            ]
        },
        {
            "id": "Static/Static-P-0004",
            "title": "승모근 자가근막이완-공(Trapezisus Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/Static-P-0004.png",
            "guide": [
                "마사지볼을 한 쪽 승모근 기시부에 두고 벽에 기대 고개를 반대쪽으로 기울여(측굴) 30초~1분간 유지한다.",
                "3~5회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "TP/TP-0018",
            "title": "승모근 자가근막이완-쎄라케인(Trapezius Self Myofascial Release, theracane)",
            "thumb": "/assets/thumbs/TP-0018.png",
            "guide": [
                "목을 한 쪽 방향으로 기울이고 근육이완 도구(쎄라케인)를 반대방향 승모근 위치에 두고 3~5초간 압박이완 한다.",
                "5~10회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0003",
            "title": "승모근 스트레치-목 측굴(Trapezius stretch, Neck side flexion)",
            "thumb": "/assets/thumbs/Stretch-0003.png",
            "guide": [
                "척추를 바로 세우고 앉거나 서서 목을 옆으로 굽혀서 15초간 유지한다.",
                "양쪽 모두 실시하고 3회씩 반복한다."
            ]
        },
    ],
    "neck_longus": [
        {
            "id": "Static/Static-F-0038",
            "title": "경장근 활성화(Longus coli activation-chin tuck)",
            "thumb": "/assets/thumbs/Static-F-0038.png",
            "guide": [
                "경추를 바로 세워 턱을 수평으로 뒤로 당겨 이중턱을 만들고 5초간 유지한다.",
                "3~5회 반복하여 실시한다."
            ]
        },
        {
            "id": "Static/Static-S-0022",
            "title": "경장근 활성화-누워서 목 굴곡저항(Longus coli activation- Static Neck Flexion, supine)",
            "thumb": "/assets/thumbs/Static-S-0022.png",
            "guide": [
                "벤치에 누워 손바닥을 이마에 댄다.",
                "목을 들어 앞으로 굽히려는 힘을 쓰고 손으로는 막아 5초간 버틴다.(3~5회 반복)"
            ]
        },
        {
            "id": "Static/Static-S-0047",
            "title": "경장근 활성화-네발기기자세 턱 당기기(Longus coli activation-Chin Tuck, Quadruped)",
            "thumb": "/assets/thumbs/Static-S-0047.png",
            "guide": [
                "네 발기기 자세로 엎드려 턱을 수평으로 뒤로 당겨 이중턱을 만들고 5초간 유지한다.(5~10번 반복)"
            ]
        },
    ],
    "neck_multifidus": [
        {
            "id": "FR/FR-0001",
            "title": "후두하근 자가근막이완-폼롤러(Suboccipital Muscle Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0001.png",
            "guide": [
                "뒷목덜미에 폼롤러를 가로로 두고 바로 누워 목을 천천히 좌우로 회전한다.(10회 3세트 반복)"
            ]
        },
        {
            "id": "Static/Static-S-0003",
            "title": "후두하근 자가근막이완-공(Suboccipital muscle Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/Static-S-0003.png",
            "guide": [
                "땅콩볼을 후두부에 두고 바로 누워 후두하근을 30초~1분 이내로 압박이완 한다.(3회 반복)"
            ]
        },
        {
            "id": "Stretch/Stretch-0008",
            "title": "수건을 이용한 후두하근 스트레치(Suboccipital muscle stretch with towel)",
            "thumb": "/assets/thumbs/Stretch-0008.png",
            "guide": [
                "척추를 바르게 세우고 앉아 수건을 목 뒤 후두부에 턱을 살짝 들어올린다.",
                "손으로 수건 양 끝을 잡아 위쪽으로 10초간 당긴다.(3회 반복)"
            ]
        },
    ],
    "neck_trap_middle": [
        {
            "id": "FR/FR-0003",
            "title": "흉추신전운동-폼롤러(Thoracic Extension exercise, foam roller)",
            "thumb": "/assets/thumbs/FR-0003.png",
            "guide": [
                "등에 폼롤러를 가로로 두고 누워 엉덩이를 들고, 양 팔을 가슴앞으로 팔짱을 끼거나 목 뒤로 깎지를 낀다.",
                "다리로 지지하고 가슴을 펴서 폼롤러를 위아래로 굴린다.",
                "30초~1분간 3~5회 반복한다."
            ]
        },
        {
            "id": "Static/Static-P-0004",
            "title": "승모근 자가근막이완-공(Trapezisus Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/Static-P-0004.png",
            "guide": [
                "마사지볼을 한 쪽 승모근 기시부에 두고 벽에 기대 고개를 반대쪽으로 기울여(측굴) 30초~1분간 유지한다.",
                "3~5회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "TP/TP-0018",
            "title": "승모근 자가근막이완-쎄라케인(Trapezius Self Myofascial Release, theracane)",
            "thumb": "/assets/thumbs/TP-0018.png",
            "guide": [
                "목을 한 쪽 방향으로 기울이고 근육이완 도구(쎄라케인)를 반대방향 승모근 위치에 두고 3~5초간 압박이완 한다.",
                "5~10회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0003",
            "title": "승모근 스트레치-목 측굴(Trapezius stretch, Neck side flexion)",
            "thumb": "/assets/thumbs/Stretch-0003.png",
            "guide": [
                "척추를 바로 세우고 앉거나 서서 목을 옆으로 굽혀서 15초간 유지한다.",
                "양쪽 모두 실시하고 3회씩 반복한다."
            ]
        },
    ],

    "shoulder_supraspinatus": [
        {
            "id": "TP/TP-0037",
            "title": "극상근 자가근막이완-쎄라케인(Supraspinatus self myofascial release, theracane)",
            "thumb": "/assets/thumbs/TP-0037.png",
            "guide": [
                "쎄라케인을 목덜미 중간과 어깨쪽 1/3 지점에 대고 손으로 당겨 압박한다.",
                "30초~1분간 유지하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0036",
            "title": "극상근 자가근막이완-공(Supraspinatus self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0036.png",
            "guide": [
                "마사지볼로 목덜미 중간과 어깨쪽 1/3 지점을 압박한다.",
                "30초~1분간 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0012",
            "title": "극상근 스트레치(Supraspinatus stretch)",
            "thumb": "/assets/thumbs/Stretch-0012.png",
            "guide": [
                "양 팔을 허리 뒤로 보내(어깨 내회전) 한 손으로 반대쪽 손목을 잡아 바깥쪽으로 당긴다.",
                "15초간 유지하고, 3세트 반복한다."
            ]
        },
    ],

    "shoulder_infraspinatus": [
        {
            "id": "TP/TP-0040",
            "title": "극하근 자가근막이완-공(Infraspinatus self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0040.png",
            "guide": [
                "마사지볼을 견갑골(어깨뼈) 중앙에 두고 바로 눕는다.",
                "어깨를 후인하여 견갑골을 가볍게 압박시켜 30초 유지하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0013",
            "title": "극하근 스트레치(Infraspinatus stretch)",
            "thumb": "/assets/thumbs/Stretch-0013.png",
            "guide": [
                "한 쪽 팔꿈치를 굽혀 손등을 허리와 등의 중간 부분에 댄 후 반대쪽 손으로 팔꿈치를 지그시 앞으로 당긴다.",
                "(단, 팔을 뒤로 보낼 수 없는 경우 영상처럼 손을 허리에 두고 실시한다.)",
                "15초간 유지한 후 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0014",
            "title": "극하근 스트레치(Infraspinatus stretch-sidelying)",
            "thumb": "/assets/thumbs/Stretch-0014.png",
            "guide": [
                "옆으로 누워 아래쪽 팔을 가슴 앞으로 보낸다.",
                "아래쪽 팔꿈치를 굽혀 손바닥이 앞을 향하도록 수직으로 세우고 반대쪽 손으로 손등을 잡아 아래로 밀어 내린다.",
                "15초 유지하고, 3세트 반복한다."
            ]
        },
    ],

    "shoulder_teres_major": [
        {
            "id": "TP/TP-0051",
            "title": "대원근 자가근막이완-폼롤러(Teres major self myofascial release",
            "thumb": "/assets/thumbs/TP-0051.png",
            "guide": [
                "겨드랑이 사이에 폼롤러를 두고 옆으로 눕는다.",
                "옆쪽으로 대원근을 압박하면서 30초~1분 내외로 폼롤러를 위아래로 굴린다.",
                "3~5회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "TP/TP-0052",
            "title": "대원근 자가근막이완-공(Teres major self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0052.png",
            "guide": [
                "한 쪽 견갑골 아래쪽에 마사지볼을 두고 뒤쪽으로 몸을 밀어 대원근을 압박이완 한다.",
                "30초~1분간 유지하여 3~5회 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0022",
            "title": "광배근 스트레치-짐볼(Latissimus Dorsi stretch, Stability ball)",
            "thumb": "/assets/thumbs/Stretch-0022.png",
            "guide": [
                "네 발 기기 자세로 엎드려 한 손을 짐볼 위에 올린다.",
                "팔을 외회전시켜 팔꿈치를 펴면서 짐볼을 앞으로 밀어내서 15초 유지한다.",
                "3회 반복하고, 반대쪽도 실시한다."
            ]
        },
    ],

    "shoulder_deltoid": [
        {
            "id": "FR/FR-0006",
            "title": "삼각근 자가근막이완-폼롤러(Deltoid Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0006.png",
            "guide": [
                "팔을 펴서 어깨 아래에 폼롤러를 두고 옆으로 눕는다.",
                "30초~1분간 폼롤러를 위아래로 굴려 삼각근을 압박한다.",
                "3~5회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "TP/TP-0034",
            "title": "삼각근 자가근막이완-공(Deltoid self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0034.png",
            "guide": [
                "어깨 아래에 마사지볼을 두고 옆으로 눕는다.",
                "체중을 실어 30초~1분간 삼각근을 압박하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0009",
            "title": "전삼각근 스트레치(Anterior Deltoid stretch)",
            "thumb": "/assets/thumbs/Stretch-0009.png",
            "guide": [
                "허리 뒤로 깍지를 껴 팔을 뻗어 올리고 15초간 유지한다. 3회 반복한다."
            ]
        },
    ],

    "shoulder_teres_minor": [
        {
            "id": "TP/TP-0039(teres minor)",
            "title": "소원근 자가근막이완-공(Teres Minor self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0039(teres minor).png",
            "guide": [
                "마사지볼을 어깨 견갑골(어깨뼈) 중앙에 두고 바로 눕는다.",
                "어깨를 후인하여 견갑골 아래쪽을 가볍게 압박하여 30초 유지하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0014",
            "title": "극하근 스트레치(Infraspinatus stretch-sidelying)",
            "thumb": "/assets/thumbs/Stretch-0014.png",
            "guide": [
                "옆으로 누워 아래쪽 팔을 가슴 앞으로 보낸다.",
                "아래쪽 팔꿈치를 굽혀 손바닥이 앞을 향하도록 수직으로 세우고 반대쪽 손으로 손등을 잡아 아래로 밀어 내린다.",
                "15초 유지하고, 3세트 반복한다."
            ]
        },
    ],

    "shoulder_rotator_cuff": [
        {
            "id": "CB/CB-0021",
            "title": "회전근개활성화-어깨 외회전 운동(Rotator cuff activation-External Rotation workout)",
            "thumb": "/assets/thumbs/CB-0021.png",
            "guide": [
                "케이블 옆으로 서서 바깥쪽 손으로 케이블 손잡이를 잡는다.",
                "케이블을 잡은 팔을 90°로 굽혀 몸 옆에 붙이고 전완(팔꿈치 아래)을 밖으로 회전한다.(어깨 외회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Static/Static-S-0025",
            "title": "하부승모근/회전근개 활성화(Lower Trapezius/Rotator cuff activation-Y, W, T’s on Stability ball)",
            "thumb": "/assets/thumbs/Static-S-0025.png",
            "guide": [
                "양손에 덤벨을 들고 짐볼 위에 엎드린다.",
                "가슴을 펴고 팔을 Y, W, T자 형태로 만들어 귀높이로 들어 올린다.",
                "10회 3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0016",
            "title": "회전근개 활성화(Rotator cuff activation-Scaption)",
            "thumb": "/assets/thumbs/Dumbbell-0016.png",
            "guide": [
                "양 손에 덤벨을 들고 어깨를 가볍게 외회전 시킨다.",
                "팔을 벌려(양 팔의 각도 약 120°) 손을 이마높이까지 들어 올린 후 견갑골 사이를 수축시켰다 푼다.",
                "10~15회 3세트 반복한다."
            ]
        },
    ],

    "arm_brachialis": [
        {
            "id": "TP/TP-0073",
            "title": "상완근 통증유발점 자가근막이완-공(Brachialis self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0073.png",
            "guide": [
                "마사지공을 상완(위쪽 팔) 앞쪽 측면부에 두고 압박하면서 굴려 마사지한다.",
                "30초~1분간 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0071",
            "title": "상완근 스트레치(Brachialis stretch)",
            "thumb": "/assets/thumbs/Stretch-0071.png",
            "guide": [
                "손바닥이 위로 향하게 하여 팔을 가슴앞으로 뻗는다.",
                "반대쪽 손으로 손바닥을 감싸 몸쪽으로 당기고 15초 유지한다.",
                "같은 방법으로 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
    ],
    "arm_triceps": [
        {
            "id": "FR/FR-0005",
            "title": "삼두근 자가근막이완-폼롤러(Triceps self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0005.png",
            "guide": [
                "옆으로 누워 아래쪽 팔을 손바닥이 위를 향하도록 머리 위로 뻗어 팔꿈치 윗부분에 폼롤러를 둔다.",
                "폼롤러를 위아래로 굴려 삼두근을 압박이완 한다.",
                "30초~1분간 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0022",
            "title": "삼두근 자가근막이완-작은 폼롤러(Triceps self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0022.png",
            "guide": [
                "팔을 굽혀 폼롤러를 팔꿈치 위쪽에 두고 앉는다.",
                "체중을 실으면서 폼롤러를 앞뒤로 굴려 삼두근을 압박이완 한다.",
                "30초~1분간 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0011",
            "title": "삼두근 스트레치(Triceps stretch)",
            "thumb": "/assets/thumbs/Stretch-0011.png",
            "guide": [
                "한 팔을 위로 들어 팔꿈치를 굽히고, 반대쪽 손으로 팔꿈치를 잡아 뒤로 당겨 15초 유지한다.",
                "팔을 바꿔 반대쪽으로도 실시하고, 2~3세트 반복한다."
            ]
        },
    ],
    "arm_brachioradialis": [
        {
            "id": "TP/TP-0076",
            "title": "상완요골근 자가근막이완-공(Brachioradialis self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0076.png",
            "guide": [
                "테이블에 팔을 올려 엄지방향의 전완(팔꿈치 아래) 윗부분에 마사지볼을 댄다.",
                "체중을 실으면서 압박하듯 마사지공을 굴려 상완요골근을 마사지 한다.",
                "30초~1분간 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0077",
            "title": "상완요골근 자가근막이완-셀프마사지(Brachioradialis self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0077.png",
            "guide": [
                "전완(팔꿈치 아래)의 엄지손가락 방향(팔꿈치 약간 아래)에 마사지 공을 두고 위아래로 굴리면서 마사지한다.",
                "30초~1분간 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0074",
            "title": "상완요골근스트레치 (Brachioradialis stretch)",
            "thumb": "/assets/thumbs/Stretch-0074.mp4_000010591.png",
            "guide": [
                "손바닥을 아래로 향하게 하여 오른 팔을 가슴앞으로 뻗어 손목을 바닥방향으로 굽힌다.",
                "왼손으로 오른쪽 손등을 감싼 후 새끼손가락이 안쪽으로 향하게 당겨 10~15초 유지한다.",
                "같은 방법으로 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
    ],
    "arm_biceps": [
        {
            "id": "FR/FR-0004",
            "title": "상완이두근 자가근막이완-폼롤러 (Biceps self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0004.png",
            "guide": [
                "바닥에 엎드려 팔을 옆으로 뻗어 상완(팔꿈치 위) 아래에 폼롤러를 둔다.",
                "팔을 좌우로 움직여 상완이두근이 압박이완 되도록 한다.",
                "30초~1분간 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0071",
            "title": "상완이두근 통증유발점 자가근막이완-공(Biceps Brachii self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0071.png",
            "guide": [
                "마사지볼을 상완(팔꿈치 위) 앞쪽에 두고 압박하면서 굴려 마사지한다.",
                "30초~1분간 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0009(Biceps)",
            "title": "상완이두근 스트레치(Biceps stretch)",
            "thumb": "/assets/thumbs/Stretch-0009(Biceps).png",
            "guide": [
                "손바닥이 위로 향하게 하여 오른팔을 가슴앞으로 뻗는다.",
                "왼손으로 오른쪽 손바닥을 감싸 몸쪽으로 당기고 15초간 유지한다.",
                "같은 방법으로 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
    ],
    "arm_flexor": [
        {
            "id": "TP/TP-0084(flexor digitorum)",
            "title": "수지굴근 자가근막이완-공(Flexor carpi muscle self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0084(flexor digitorum).png",
            "guide": [
                "손바닥을 아래로 향하게 하여 전완(팔꿈치 아래)에 마사지공을 둔다.",
                "체중을 가볍게 실어 마사지공을 앞뒤로 굴려 수지굴근을 마시지한다.",
                "30초~1분간 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0084",
            "title": "수지굴근 자가근막이완-셀프마사지(Flexor carpi muscle self myofascial release)",
            "thumb": "/assets/thumbs/TP-0084.png",
            "guide": [
                "전완(팔꿈치 아래)의 안쪽(손바닥 방향)을 반대손 엄지손가락을 이용하여 압박하면서 마사지한다.",
                "30초~1분간 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0069",
            "title": "손목 굴곡/신전 스트레치(Wirst flexion/extension stretch)",
            "thumb": "/assets/thumbs/Stretch-0069.png",
            "guide": [
                "한 팔을 가슴앞으로 뻗어 반대쪽 손으로 손바닥을 감싸 손등쪽으로 당겨(신전) 5초간 유지한다.",
                "원위치로 돌아와 손등을 감싸 바닥쪽으로 당겨(굴곡) 5초간 유지한다.",
                "10회 반복하여 3세트 실시한다."
            ]
        },
    ],
    "arm_pronator_teres": [
        {
            "id": "TP/TP-0078",
            "title": "원회내근 자가근막이완-공(Pronator Teres self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0078.png",
            "guide": [
                "손바닥을 아래로 향하게 하여 전완(팔꿈치 아래)에 마사지공을 둔다.",
                "체중을 가볍게 실어 마사지공을 앞뒤로 굴려 수지굴근을 마시지한다.",
                "30초~1분간 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0079",
            "title": "원회내근 자가근막이완-셀프마사지 (Pronator Teres self myofascial release)",
            "thumb": "/assets/thumbs/TP-0079.png",
            "guide": [
                "전완(팔꿈치 아래)의 안쪽(손바닥 방향)을 반대손 엄지손가락을 이용하여 압박하면서 마사지한다.",
                "30초~1분간 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0075",
            "title": "원회내근 스트레치(Pronator Teres stretch)",
            "thumb": "/assets/thumbs/Stretch-0075.png",
            "guide": [
                "손바닥이 위로 향하게 하여 오른팔을 가슴앞으로 뻗는다.",
                "왼손으로 오른쪽 손바닥을 감싸 몸쪽으로 당기고 15초간 유지한다.",
                "같은 방법으로 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
    ],
    "arm_palmaris_longus": [
        {
            "id": "TP/TP-0083",
            "title": "장장근 자가근막이완-공(Palmaris Longus self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0083.png",
            "guide": [
                "손바닥을 위로 향하게 하여 전완(팔꿈치 아래) 팔꿈치 내측(척측) 1/3지점에 마사지공을 댄다.",
                "공을 압박하면서 30초~1분간 굴리고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Palmaris Longus",
            "title": "장장근 스트레치(Palmaris Longus stretch)",
            "thumb": "/assets/thumbs/Palmaris Longus.mp4_000008475.png",
            "guide": [
                "네 발 기지 자세로 엎드려 어깨를 외회전 하여(손가락이 몸쪽을 향하게) 손바닥으로 바닥을 짚는다.",
                "15초 유지하고, 3세트 반복한다."
            ]
        },
    ],
    "arm_supinator": [
        {
            "id": "TP/TP-0085(supinator)",
            "title": "회외근 자가근막이완-공(Supinator self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0085(supinator).png",
            "guide": [
                "테이블에 팔꿈치를 굽혀 엄지손가락이 바깥으로 향하게(어깨 외회전)한다.",
                "마사지공을 엄지손가락 쪽 팔꿈치 위치에 두고 압박하면서 굴린다. 30초~1분 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0081",
            "title": "회외근 자가근막이완-셀프마사지(Supinator self myofascial release)",
            "thumb": "/assets/thumbs/TP-0081.png",
            "guide": [
                "환측 엄지손가락 쪽 팔꿈치 부위를 반대쪽 손의 엄지손가락을 이용하여 마사지 한다.",
                "30초~1분 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0076",
            "title": "회외근 스트레치(Supinator stretch)",
            "thumb": "/assets/thumbs/Stretch-0076.png",
            "guide": [
                "오른팔을 가슴앞으로 뻗어 어깨를 안으로 회전한다.(어깨 내회전)",
                "왼손으로 오른손을 감싼 후 엄지손가락이 바깥쪽으로 향하게 당겨 10~15초 유지한다.",
                "같은 방법으로 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
    ],
    "arm_coracobrachialis": [
        {
            "id": "FMS/FMS-OH-0109",
            "title": "오훼상완근 자가근막이완-공(Coracoid Brachi Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/FMS-OH-0109.png",
            "guide": [
                "팔 안쪽 겨드랑이와 이두근 사이에 마사지 공을 대고 체중을 실어 30초~1분 이내로 압박한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
    ],
    "abdomen_rectus": [
        {
            "id": "Static/Static-S-0100",
            "title": "복직근 자가근막이완-쿠션볼(Rectus Abdominis Self Myofascial Release, Cushion ball)",
            "thumb": "/assets/thumbs/Static-S-0100.png",
            "guide": [
                "복부에 쿠션볼이나 마사지볼을 두고 엎드려 위아래로 굴리며 복직근을 압박이완 한다.",
                "30초~1분 내외로 3~5회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0031",
            "title": "복부 스트레치-짐볼(Abdominal stretch, Stability ball)",
            "thumb": "/assets/thumbs/Stretch-0031.png",
            "guide": [
                "짐볼 위에 등을 대고 누워 팔을 위로 뻗고 15초간 유지한다.(3회 반복)"
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0047",
            "title": "복직근 스트레치(Rectus Abdominis stretch)",
            "thumb": "/assets/thumbs/PilatesMat-0047.mp4_000007991.png",
            "guide": [
                "다리를 펴고 엎드려 양 팔을 굽혀 몸 옆에 둔다.",
                "팔꿈치를 펴 상체를 세워 15초 유지하고, 3회 반복한다."
            ]
        },
    ],
    "lumbar_quadratus": [
        {
            "id": "TP/TP-0002(QL)",
            "title": "요방형근 자가근막이완-폼롤러(Quadratus lumborum Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/TP-0002.png",
            "guide": [
                "허리와 골반 사이(요방형근)에 폼롤러를 가로로 두고 눕는다.",
                "체중을 실어 굴리듯이 폼롤러를 위 아래로 굴려 30초~1분간 요방형근을 압박한다.",
                "반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0003(QL)",
            "title": "요방형근 자가근막이완-공(Quadratus lumborum Self Myofascial Release-Ball)",
            "thumb": "/assets/thumbs/TP-0003(QL).png",
            "guide": [
                "허리 옆(요방형근 위치)에 마사지볼을 두고 벽 옆에 서서 팔을 위로 뻗는다.",
                "몸을 벽쪽으로 밀어 30초~1분간 요방형근을 압박한다.",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0027",
            "title": "요방형근 스트레치-짐볼(Quadratus lumborum stretch, Stability ball)",
            "thumb": "/assets/thumbs/Stretch-0027.png",
            "guide": [
                "짐볼 위에 옆으로 누워 팔과 다리를 위 아래로 뻗어 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0101",
            "title": "요방형근 스트레치-베드(Quadratus lumborum stretch, bed)",
            "thumb": "/assets/thumbs/MS-Lumbar-0101.png",
            "guide": [
                "침대 가장자리에 옆으로 눕는다.",
                "위쪽 다리를 뻗어 침대 밖으로 늘어뜨리고, 위쪽 팔을 위로 뻗어 옆구리(요방형근)가 스트레치 되도록 한다.",
                "15초간 유지하여 3회 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Static/Static-F-0163",
            "title": "왼쪽 요방형근 스트레치(Left Quadratus Lumborum stretch)",
            "thumb": "/assets/thumbs/Static-F-0163.png",
            "guide": [
                "왼쪽 팔꿈치를 굽혀 벽에 대고 왼쪽 다리를 오른쪽 다리 뒤로 교차시킨다.",
                "척추를 곧게 세운 채 골반을 벽쪽으로 밀어 15초간 유지하고, 3세트 반복한다."
            ]
        },
    ],
    "lumbar_psoas_major": [
        {
            "id": "FR/FR-0010",
            "title": "고관절 굴곡근 자가근막이완-폼롤러(Hip Flexor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0010.png",
            "guide": [
                "골반 밑(고관절 굴곡근)에 폼롤러를 두고 엎드린다.",
                "다리를 펴서 30초~1분간  폼롤러를 굴려 고관절 굴곡근을 압박이완 한다.",
                "3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0041",
            "title": "고관절 굴곡근 스트레치(Hip Flexor stretch)",
            "thumb": "/assets/thumbs/Stretch-0041.png",
            "guide": [
                "무릎을 굽혀 오른쪽 다리를 뒤로 보내고, 왼쪽 발을 앞으로 보내 바닥을 밟는다.",
                "오른팔을 위로 뻗어 상체와 함께 왼쪽으로 측굴 후 몸통을 오른쪽으로 회전하고 골반을 뒤로 기울인다.(후방전위)",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0048",
            "title": "고관절 굴곡근 & 대퇴부 스트레치(Hip Flexor & Quadriceps Stretch)",
            "thumb": "/assets/thumbs/Stretch-0048.png",
            "guide": [
                "왼발을 앞으로 보내 바닥을 밟고, 오른쪽 다리는 뒤로 보내 무릎을 굽혀 발등을 짐볼에 올린다.",
                "골반과 함께 몸을 앞쪽으로 밀어내고 15초간 유지한다.",
                "3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
    ],
    "lumbar_erector": [
        {
            "id": "FR/FR-0011",
            "title": "요추신전근 자가근막이완-폼롤러(Lumbar Erector Spinae Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0011.png",
            "guide": [
                "허리(요추부) 아래에 폼롤러를 두고 누워 30초~1분 내외로 위아래로 굴려 압박이완 한다.(3~5회 반복)"
            ]
        },
        {
            "id": "Static/Static-S-0081",
            "title": "요추신전근 자가근막이완-공(Lumbar Erector Spinea Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/Static-S-0081.png",
            "guide": [
                "땅콩볼 또는 마사지볼 위에 허리를 대고 누워 30초~1분 이내로 압박이완 한다.(3~5회 반복)"
            ]
        },
        {
            "id": "Stretch/Stretch-0026",
            "title": "요추기립근 스트레치-누워 무릎 가슴쪽 당기기(Lumbar Erector Spinae stretch-Single Knee to chest, supine)",
            "thumb": "/assets/thumbs/Stretch-0026.png",
            "guide": [
                "다리를 펴고 바로 누워 한 쪽 무릎을 굽혀 두 손으로 가슴까지 당겨 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0034",
            "title": "요추기립근 스트레치-누워 무릎굽혀 몸통돌리기(Lumbar Erector Spinae stretch-Trunk rotation, supine)",
            "thumb": "/assets/thumbs/Stretch-0034.png",
            "guide": [
                "다리를 펴고 바로 누워 한 쪽 무릎을 굽혀 반대쪽(안쪽)으로 넘기고 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0130",
            "title": "요추굴곡(Lumbar Flexion, standing - 1 leg)",
            "thumb": "/assets/thumbs/MS-Lumbar-0130.png",
            "guide": [
                "벤치를 앞으로 두고 서서 한 발을 벤치 위에 올려 무릎을 굽힌다.",
                "상체를 천천히 앞으로 숙이면서 복부를 수축하여 허리를 동그랗게 만든다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0024",
            "title": "앉아 요추기립근 스트레치(Lumbar Erector Spinae stretch-Forward Bending Fold)",
            "thumb": "/assets/thumbs/Stretch-0024.png",
            "guide": [
                "의자 끝에 앉아 양쪽 무릎을 어깨 넓이보다 넓게 벌린다.",
                "무릎 사이로 상체를 숙여 15초간 유지한다.(3회 반복)"
            ]
        },
    ],
    "abdomen_rectus_appendix": [
        {
            "id": "Static/Static-S-0100",
            "title": "복직근 자가근막이완-쿠션볼(Rectus Abdominis Self Myofascial Release, Cushion ball)",
            "thumb": "/assets/thumbs/Static-S-0100.png",
            "guide": [
                "복부에 쿠션볼이나 마사지볼을 두고 엎드려 위아래로 굴리며 복직근을 압박이완 한다.",
                "30초~1분 내외로 3~5회 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0047",
            "title": "복직근 스트레치(Rectus Abdominis stretch)",
            "thumb": "/assets/thumbs/PilatesMat-0047.mp4_000007991.png",
            "guide": [
                "다리를 펴고 엎드려 양 팔을 굽혀 몸 옆에 둔다.",
                "팔꿈치를 펴 상체를 세워 15초 유지하고, 3회 반복한다."
            ]
        },
    ],
    "lumbar_multifidus": [
        {
            "id": "MS/MS-Lumbar-0127",
            "title": "요추견인-폼롤러(Back Block Traction, foam roller)",
            "thumb": "/assets/thumbs/MS-Lumbar-0127.png",
            "guide": [
                "폼롤러 위에 누워 다리를 뻗는다.",
                "양 팔을 머리 위로 뻗어 올려 몸 전체가 늘어나도록(견인) 한다.",
                "10~15초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0011",
            "title": "요추신전근 자가근막이완-폼롤러(Lumbar Erector Spinae Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0011.png",
            "guide": [
                "허리(요추부) 아래에 폼롤러를 두고 누워 30초~1분 내외로 위아래로 굴려 압박이완 한다.(3~5회 반복)"
            ]
        },
        {
            "id": "Static/Static-S-0081",
            "title": "요추신전근 자가근막이완-공(Lumbar Erector Spinea Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/Static-S-0081.png",
            "guide": [
                "땅콩볼 또는 마사지볼 위에 허리를 대고 누워 30초~1분 이내로 압박이완 한다.(3~5회 반복)"
            ]
        },
        {
            "id": "Stretch/Stretch-0024",
            "title": "앉아 요추기립근 스트레치(Lumbar Erector Spinae stretch-Forward Bending Fold)",
            "thumb": "/assets/thumbs/Stretch-0024.png",
            "guide": [
                "의자 끝에 앉아 양쪽 무릎을 어깨 넓이보다 넓게 벌린다.",
                "무릎 사이로 상체를 숙여 15초간 유지한다.(3회 반복)"
            ]
        },
    ],
    "lumbar_quadratus_sij": [
        {
            "id": "TP/TP-0002(QL)",
            "title": "요방형근 자가근막이완-폼롤러(Quadratus lumborum Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/TP-0002(QL).png",
            "guide": [
                "허리와 골반 사이(요방형근)에 폼롤러를 가로로 두고 눕는다.",
                "체중을 실어 굴리듯이 폼롤러를 위 아래로 굴려 30초~1분간 요방형근을 압박한다.",
                "반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0003(QL)",
            "title": "요방형근 자가근막이완-공(Quadratus lumborum Self Myofascial Release-Ball)",
            "thumb": "/assets/thumbs/TP-0003(QL).png",
            "guide": [
                "허리 옆(요방형근 위치)에 마사지볼을 두고 벽 옆에 서서 팔을 위로 뻗는다.",
                "몸을 벽쪽으로 밀어 30초~1분간 요방형근을 압박한다.",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Lumbar-0101",
            "title": "요방형근 스트레치-베드(Quadratus lumborum stretch, bed)",
            "thumb": "/assets/thumbs/MS-Lumbar-0101.png",
            "guide": [
                "침대 가장자리에 옆으로 눕는다.",
                "위쪽 다리를 뻗어 침대 밖으로 늘어뜨리고, 위쪽 팔을 위로 뻗어 옆구리(요방형근)가 스트레치 되도록 한다.",
                "15초간 유지하여 3회 반복하고, 반대쪽도 실시한다."
            ]
        },
    ],
    "abdomen_external_oblique": [
        {
            "id": "FR/FR-0013",
            "title": "외복사근 자가근막이완-폼롤러(External Oblique Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0013.png",
            "guide": [
                "외측 복부 아래에 폼롤러를 두고 엎드린다.",
                "30초~1분 내외로 폼롤러를 위아래로 굴려 외복사근을 압박이완 한다.",
                "3~5회 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "FMS/FMS-ONE-0033",
            "title": "오른쪽 외복사근 스트레치(Right External Oblique stretch-Trunk Rotation)",
            "thumb": "/assets/thumbs/FMS-ONE-0033.png",
            "guide": [
                "바닥에 등을 대고 누워 무릎을 굽힌다.",
                "양쪽 무릎을 오른쪽으로 최대한 넘겨 15초간 유지한다.(3회 반복)",
                "* 이 동작은 왼쪽 내복사근 스트레치와 같다."
            ]
        },
        {
            "id": "FMS/FMS-ONE-0044",
            "title": "왼쪽 외복사근 스트레치(Left External Oblique stretch-Trunk Rotation)",
            "thumb": "/assets/thumbs/FMS-ONE-0044.png",
            "guide": [
                "오른쪽 다리를 골반높이로 뻗어 올리고 왼쪽으로 넘겨 바닥까지 내린다.",
                "15초간 유지하여 실시하고 3회 반복한다.",
                "* 이 동작은 오른쪽 내복사근 스트레치와 같다."
            ]
        },
    ],
    "abdomen_rectus_lower": [
        {
            "id": "Static/Static-S-0100",
            "title": "복직근 자가근막이완-쿠션볼(Rectus Abdominis Self Myofascial Release, Cushion ball)",
            "thumb": "/assets/thumbs/Static-S-0100.png",
            "guide": [
                "복부에 쿠션볼이나 마사지볼을 두고 엎드려 위아래로 굴리며 복직근을 압박이완 한다.",
                "30초~1분 내외로 3~5회 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0047",
            "title": "복직근 스트레치(Rectus Abdominis stretch)",
            "thumb": "/assets/thumbs/PilatesMat-0047.mp4_000007991.png",
            "guide": [
                "다리를 펴고 엎드려 양 팔을 굽혀 몸 옆에 둔다.",
                "팔꿈치를 펴 상체를 세워 15초 유지하고, 3회 반복한다."
            ]
        },
    ],
    "abdomen_rectus_upper": [
        {
            "id": "Static/Static-S-0100",
            "title": "복직근 자가근막이완-쿠션볼(Rectus Abdominis Self Myofascial Release, Cushion ball)",
            "thumb": "/assets/thumbs/Static-S-0100.png",
            "guide": [
                "복부에 쿠션볼이나 마사지볼을 두고 엎드려 위아래로 굴리며 복직근을 압박이완 한다.",
                "30초~1분 내외로 3~5회 반복한다."
            ]
        },
        {
            "id": "PilatesMat/PilatesMat-0047",
            "title": "복직근 스트레치(Rectus Abdominis stretch)",
            "thumb": "/assets/thumbs/PilatesMat-0047.mp4_000007991.png",
            "guide": [
                "다리를 펴고 엎드려 양 팔을 굽혀 몸 옆에 둔다.",
                "팔꿈치를 펴 상체를 세워 15초 유지하고, 3회 반복한다."
            ]
        },
    ],
    "abdomen_internal_oblique": [
        {
            "id": "Static/Static-S-0056",
            "title": "내복사근 자가근막이완-폼롤러(Internal oblique Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/Static-S-0056.png",
            "guide": [
                "한 쪽 외측 복부 아래에 폼롤러를 두고 엎드려 30초~1분 내외로 폼롤러를 위아래로 굴린다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0032(Internal Oblique)",
            "title": "내복사근 스트레치-누워 몸통회전(Internal Oblique stretch-Trunk rotation, supine)",
            "thumb": "/assets/thumbs/Stretch-0032(Internal Oblique).png",
            "guide": [
                "등을 대고 누워 다리를 모아 무릎을 세운다.",
                "좌우로 번갈아 가며 무릎을 최대한 바닥쪽으로 넘겨 2~3초 유지하고 돌아온다.",
                "10회 2~3세트 반복한다."
            ]
        },
    ],

    "core_stabilizer": [
        {
            "id": "Static/Static-S-0064",
            "title": "코어 및 하복부 활성화(Core activation, Static Dead bug exercise)",
            "thumb": "/assets/thumbs/Static-S-0064.png",
            "guide": [
                "한 쪽 무릎을 가슴쪽으로 올리려는 힘을 쓰고 반대손으로 저항하여 버티고, 동시에 반대쪽 팔과 다리는 바닥과 수평하게 뻗는다.",
                "5~10초간 유지한 후 팔과 다리를 바꿔 실시한다.(3~5세트 반복)"
            ]
        },
        {
            "id": "Static/Static-S-0088",
            "title": "코어강화 운동-프론트 플랭크(Core activation-Front Plank)",
            "thumb": "/assets/thumbs/Static-S-0088.png",
            "guide": [
                "팔꿈치를 90°로 굽혀 어깨와 수직으로 바닥을 지지하고 엎드린다.",
                "다리를 뻗어 머리부터 발까지 수평을 만들어 30초간 유지하고, 3세트 반복한다."
            ]
        },
    ],

    "thigh_vastus_medialis": [
        {
            "id": "TP/TP-0130",
            "title": "내측광근 자가근막이완-폼롤러(Vastus Medialis self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/TP-0130.png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 두고 체중을 실어 엎드린다.",
                "폼롤러를 좌우로 움직여 30초~1분 내외로 내측광근을 압박이완하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0095",
            "title": "내측광근 자가근막이완-공(Vastus Medialis self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0095.png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 마사지볼을 두고 체중을 실어 엎드린다.",
                "마사지볼을 굴려 30초~1분 내외로 내측광근을 압박이완하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0081",
            "title": "내측광근 스트레치(Vastus Medialis stretch)",
            "thumb": "/assets/thumbs/Stretch-0081.png",
            "guide": [
                "한 쪽 무릎을 굽혀 두 손을 무릎 앞으로 깎지를 껴서 가슴쪽으로 끌어 당긴다.",
                "15초 유지한 후 다리를 바꿔 실싷고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0052",
            "title": "대퇴부 신전 스트레치-서서(Quadriceps stretch, standing)",
            "thumb": "/assets/thumbs/Stretch-0052.png",
            "guide": [
                "한 쪽 무릎을 굽혀 뒤쪽에서 손으로 발목을 잡아 당기며 15초 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
    ],
    "thigh_adductor_magnus": [
        {
            "id": "FR/FR-0015",
            "title": "고관절 내전근 자가근막이완-폼롤러(Hip Adductor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0015.png",
            "guide": [
                "앞으로 엎드려 폼롤러를 안쪽 내전근에 놓고 체중을 이용하여 압박한다. 30초 3회 반복한다."
            ]
        },
        {
            "id": "TP/TP-0110",
            "title": "대내전근 자가근막이완-공(Adductor Magnus self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0110.png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 마사지공을 대고 엎드린다.",
                "마사지공에 체중을 실어 30초~1분 내외로 압박이완 한다.",
                "같은 방법으로 반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0043",
            "title": "고관절 내전근 스트레치(Hip Adductor stretch)",
            "thumb": "/assets/thumbs/Stretch-0043.png",
            "guide": [
                "다리를 넓게 벌리고 서서 오른발을 바깥쪽으로 회전한다.(고관절 외전, 외회전)",
                "왼쪽 무릎을 굽히고 앉으면서 체중을 실어 15초간 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0045",
            "title": "내전근 스트레치-스텝박스(Adductor stretch, step)",
            "thumb": "/assets/thumbs/Stretch-0045.png",
            "guide": [
                "스텝박스를 옆으로 두고 선다.",
                "한 발을 스텝박스에 올리고, 반대쪽 다리는 옆으로 뻗어 발을 바깥쪽으로 회전한다.",
                "스텝박스에 올린 다리의 무릎을 굽히고 상체를 옆으로 뻗은 다리쪽으로 숙여 15초 유지한다.",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
    ],
    "thigh_tfl": [
        {
            "id": "FR/FR-0012",
            "title": "대퇴근막장근 자가근막이완-폼롤러(TFL Self Myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0012.png",
            "guide": [
                "옆으로 골반 쪽에 폼롤러들 두고 골반 아래 대퇴근막장근을 압박이완 한다. 30초~1분내외 3회반복한다. 양쪽 모두 수행한다"
            ]
        },
        {
            "id": "TP/TP-0089",
            "title": "대퇴근막장근 자가근막이완-공(TFL Self Myofascial Release, ball)",
            "thumb": "/assets/thumbs/TP-0089.png",
            "guide": [
                "골반 아래부분(대퇴근막장근)에 마사지볼을 두고 옆으로 눕는다.",
                "체중을 실어 30초~1분간 몸을 위아래로 움직인다.",
                "3~5회 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0041(TFL)",
            "title": "앉아서 대퇴근막장근 스트레치(TFL stretch, sit position)",
            "thumb": "/assets/thumbs/Stretch-0041(TFL).png",
            "guide": [
                "무릎을 90°로 굽히고 세워 한 쪽 다리를 앞으로 보낸다.",
                "뒤쪽 다리와 같은 방향의 팔을 위로 뻗어 몸통과 함께 반대방향으로 기울인(측굴) 후 바깥쪽으로 가볍게 회전한다.",
                "15초간 유지하여 3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0042",
            "title": "서서 대퇴근막장근 스트레치(TFL stretch, stand)",
            "thumb": "/assets/thumbs/Stretch-0042.png",
            "guide": [
                "한 쪽 다리를 뒤로 보내고 같은 쪽 팔을 위로 뻗어 올려 몸과 함께 반대방향으로 측굴하여 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
    ],
    "thigh_rectus_femoris": [
        {
            "id": "FR/FR-0010",
            "title": "고관절 굴곡근 자가근막이완-폼롤러(Hip Flexor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0010.png",
            "guide": [
                "골반 밑(고관절 굴곡근)에 폼롤러를 두고 엎드린다.",
                "다리를 펴서 30초~1분간  폼롤러를 굴려 고관절 굴곡근을 압박이완 한다.",
                "3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0093TP-0093(rectus femoris)",
            "title": "대퇴직근 자가근막이완-공(Rectus Femoris self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0093.png",
            "guide": [
                "골반 밑 허벅지 위쪽(대퇴직근)에 마사지볼을 두고 엎드린다.",
                "마사지볼에 체중을 싣고 30초~1분간 지긋이 눌러 압박이완 한다.",
                "같은 방법으로 반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0041",
            "title": "고관절 굴곡근 스트레치(Hip Flexor stretch)",
            "thumb": "/assets/thumbs/Stretch-0041.png",
            "guide": [
                "무릎을 굽혀 오른쪽 다리를 뒤로 보내고, 왼쪽 발을 앞으로 보내 바닥을 밟는다.",
                "오른팔을 위로 뻗어 상체와 함께 왼쪽으로 측굴 후 몸통을 오른쪽으로 회전하고 골반을 뒤로 기울인다.(후방전위)",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0048",
            "title": "고관절 굴곡근 & 대퇴부 스트레치(Hip Flexor & Quadriceps Stretch)",
            "thumb": "/assets/thumbs/Stretch-0048.png",
            "guide": [
                "왼발을 앞으로 보내 바닥을 밟고, 오른쪽 다리는 뒤로 보내 무릎을 굽혀 발등을 짐볼에 올린다.",
                "골반과 함께 몸을 앞쪽으로 밀어내고 15초간 유지한다.",
                "3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
    ],
    "thigh_gracilis": [
        {
            "id": "TP/TP-0112",
            "title": "박근 자가근막이완-폼롤러(Gracilis self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/TP-0112.png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 두고 체중을 실어 엎드린다.",
                "폼롤러를 좌우로 움직여 30초~1분 내외로 박근을 압박이완(마사지) 한다.",
                "반대쪽도 같은 방법으로 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0091",
            "title": "박근 자가근막이완-공(Gracilis self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0091.png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 마사지볼을 두고 체중을 실어 엎드린다.",
                "마사지볼을 굴려 30초~1분 내외로 박근을 압박이완(마사지) 한다.",
                "반대쪽도 같은 방법으로 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0043",
            "title": "고관절 내전근 스트레치(Hip Adductor stretch)",
            "thumb": "/assets/thumbs/Stretch-0043.png",
            "guide": [
                "다리를 넓게 벌리고 서서 오른발을 바깥쪽으로 회전한다.(고관절 외전, 외회전)",
                "왼쪽 무릎을 굽히고 앉으면서 체중을 실어 15초간 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0045",
            "title": "내전근 스트레치-스텝박스(Adductor stretch, step)",
            "thumb": "/assets/thumbs/Stretch-0045.png",
            "guide": [
                "스텝박스를 옆으로 두고 선다.",
                "한 발을 스텝박스에 올리고, 반대쪽 다리는 옆으로 뻗어 발을 바깥쪽으로 회전한다.",
                "스텝박스에 올린 다리의 무릎을 굽히고 상체를 옆으로 뻗은 다리쪽으로 숙여 15초 유지한다.",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "FMS/FMS-OH-0008",
            "title": "내전근 스트레치-짐볼(Adductor stretch, Stability ball)",
            "thumb": "/assets/thumbs/FMS-OH-0008.png",
            "guide": [
                "짐볼에 앉아 한 쪽 다리를 옆으로 쭉 펴고 발을 족배굴곡(발등 굽힘)한다.",
                "무릎을 굽힌 다리쪽으로 체중을 옮겨 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
    ],
    "thigh_sartorius": [
        {
            "id": "FR/FR-0015",
            "title": "고관절 내전근 자가근막이완-폼롤러(Hip Adductor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0015.png",
            "guide": [
                "앞으로 엎드려 폼롤러를 안쪽 내전근에 놓고 체중을 이용하여 압박한다. 30초 3회 반복한다."
            ]
        },
        {
            "id": "TP/TP-0116",
            "title": "봉공근 자가근막이완-공(Sartorius self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0116.png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 마사지볼을 두고 체중을 실어 엎드린다.",
                "마사지볼을 굴려 30초~1분 내외로 박근을 압박이완(마사지) 한다.",
                "반대쪽도 같은 방법으로 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0077",
            "title": "봉공근 스트레치(Sartorius stretch)",
            "thumb": "/assets/thumbs/Stretch-0077.png",
            "guide": [
                "스트레치 하고자 하는 다리를 뒤로 보내(고관절신전) 안쪽 45° 방향으로 길게 뻗고(고관절내전) 발을 내회전 한다.",
                "10~15초 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다.",
                "※ 봉공근은 고관절 굴곡, 외전, 외회전 보조근육이다."
            ]
        },
    ],
    "thigh_hamstrings": [
        {
            "id": "Static/Static-F-0177",
            "title": "햄스트링 자가근막이완-폼롤러(Hamstring Self Myofascial release, foam roller)",
            "thumb": "/assets/thumbs/Static-F-0177.png",
            "guide": [
                "허벅지 뒤쪽에 폼롤러를 가로로 두고 앚아 다리를 뻗고 엉덩이를 든다.",
                "팔로 지지하여 폼롤러를 굴리듯이 위아래로 움직여 30초~1분 내외로 햄스트링을 압박이완 한다.(3~5회 반복)"
            ]
        },
        {
            "id": "TP/TP-0096",
            "title": "슬굴곡근 자가근막이완-공(Hamstring self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0096.png",
            "guide": [
                "엉덩이 아래쪽과 오금 중간 허벅지 밑에 마사지공을 두고 앉는다.",
                "엉덩이를 들어 체중을 실어 마사지볼을 위아래로 30초~1분간 굴려 슬굴곡근을 압박이완(마시지) 한다.",
                "같은 방법으로 반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0055",
            "title": "햄스트링 스트레치-누워서(Hamstring stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0055.png",
            "guide": [
                "다리 펴고 누워 양 손으로 한 쪽 다리의 허벅지를 잡아 몸쪽으로 끌어당기고 15초 유지한다.",
                "양쪽 다리를 번갈아 가며 3회씩 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0036",
            "title": "벽 기대고 햄스트링 스트레치(Hamstring Stretch, Supine at Wall)",
            "thumb": "/assets/thumbs/MS-Knee-0036.png",
            "guide": [
                "바닥에 등을 대고 누워 한 쪽 다리를 펴서 벽에 기댄다.",
                "햄스트링의 상태에 따라 벽 위로 밀어올리면서 무릎을 편다.",
                "5초간 유지하고, 10세트 반복한다."
            ]
        },
    ],
    "thigh_popliteus": [
        {
            "id": "FR/FR-0024",
            "title": "슬와근 자가근막이완-폼롤러(Popliteus self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0024.png",
            "guide": [
                "무릎 뒤쪽 오금 밑에 폼롤러를 가로로 두고 앉는다.",
                "엉덩이를 들어 폼롤러에 체중을 실어 위아래로 30초~1분간 굴려 슬와근을 압박이완(마시지) 한다.",
                "같은 방법으로 반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0097",
            "title": "슬와근 자가근막이완-공(Popliteus self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0097.png",
            "guide": [
                "무릎 뒤쪽 오금 밑에 마사지볼을 두고 앉는다.",
                "엉덩이를 들어 마사지볼에 체중을 실어 위아래로 30초~1분간 굴려 슬와근을 압박이완(마시지) 한다.",
                "같은 방법으로 반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0078",
            "title": "슬와근 스트레치(Popliteus stretch)",
            "thumb": "/assets/thumbs/Stretch-0078.png",
            "guide": [
                "의자에 앉아 무릎을 굽히고 발을 바깥쪽으로 회전하여 15초간 유지한다.",
                "같은 방법으로 발을 바꿔 실시하고, 3세트 반복한다."
            ]
        },
    ],
    "thigh_vastus_lateralis": [
        {
            "id": "TP/TP-0127",
            "title": "외측광근 자가근막이완-폼롤러(Vastus Lateralis self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/TP-0127.png",
            "guide": [
                "대퇴부 바깥쪽이 밑으로 가도록 옆으로 누워 무릎과 골반 중간에 폼롤러를 두고 위아래로 굴린다.",
                "30초~1분 내외로 압박한 후 다리를 바꿔 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0094",
            "title": "외측광근 자가근막이완-공(Vastus Lateralis self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0094.png",
            "guide": [
                "대퇴부 바깥쪽이 밑으로 가도록 옆으로 누워 무릎과 골반 중간에 마사지볼을 두고 위아래로 굴린다.",
                "30초~1분 내외로 압박한 후 다리를 바꿔 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0052",
            "title": "대퇴부 신전 스트레치-서서(Quadriceps stretch, standing)",
            "thumb": "/assets/thumbs/Stretch-0052.png",
            "guide": [
                "한 쪽 무릎을 굽혀 뒤쪽에서 손으로 발목을 잡아 당기며 15초 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
    ],
    "thigh_adductor_longus": [
        {
            "id": "FR/FR-0015",
            "title": "내전근 자가근막이완-폼롤러(Adductor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0015.png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 두고 엎드린다.",
                "폼롤러에 체중을 싣고 30초~1분간 좌우로 굴려 내전근을 압박이완한다.",
                "반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0113(Adductor longus)",
            "title": "장내전근 자가근막이완-공(Hip Adductor self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0113(adductor longus).mp4_000007807.png",
            "guide": [
                "옆으로 누워 위 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 세로로 둔다.",
                "폼롤러에 올린 다리의 서혜부와 폼롤러 사이에 마사지공을 두고 체중을 실어 30초~1분간 압박한다.",
                "3~5세트 반복하고, 반대쪽으로도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0047",
            "title": "장내전근 스트레치(Hip Adductor stretch)",
            "thumb": "/assets/thumbs/Stretch-0047.png",
            "guide": [
                "발바닥을 붙이고 앉아 무릎을 양 옆으로 벌린다.",
                "팔꿈치로 다리를 누르거나 상체를 앞으로 숙여 15초 유지하고, 3세트 반복한다."
            ]
        },
    ],
    "thigh_vastus_intermedius": [
        {
            "id": "FR/FR-0010(Vastus medialis)",
            "title": "중간광근 자가근막이완-폼롤러(Vastus Intermedius self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0010(Vastus medialis).png",
            "guide": [
                "골반 밑 허벅지 위쪽(중간 광근)에 폼롤러를 가로로 두고 엎드린다.",
                "다리를 펴고 30초~1분간 폼롤러를 위아래로 굴려 중간 광근을 압박이완 하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0131(vastus medius)",
            "title": "중간광근 자가근막이완-공(Vastus Intermedius self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0131(vastus medius).png",
            "guide": [
                "골반 밑 허벅지 위쪽(중간 광근)에 마사지볼을 두고 엎드린다.",
                "마사지볼에 체중을 싣고 30초~1분간 지긋이 눌러 압박이완 한다.",
                "같은 방법으로 반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0052",
            "title": "대퇴부 신전 스트레치-서서(Quadriceps stretch, standing)",
            "thumb": "/assets/thumbs/Stretch-0052.png",
            "guide": [
                "한 쪽 무릎을 굽혀 뒤쪽에서 손으로 발목을 잡아 당기며 15초 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
    ],
    "thigh_pectineus": [
        {
            "id": "FR/FR-0015(pectineus)",
            "title": "치골근 자가근막이완-폼롤러(Pectineus self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0015(pectineus).png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 두고 체중을 싣고 엎드린다.",
                "30초~1분간 폼롤러를 좌우로 굴려 3~5세트 반복하고, 같은 방법으로 반대쪽도 실시한다."
            ]
        },
        {
            "id": "TP/TP-0092",
            "title": "치골근 자가근막이완-공(Pectineus self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0092.png",
            "guide": [
                "옆으로 누워 위 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 세로로 둔다.",
                "폼롤러에 올린 다리의 서혜부와 폼롤러 사이에 마사지공을 두고 체중을 실어 30초~1분간 압박한다.",
                "3~5세트 반복하고, 같은 방법으로 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0047",
            "title": "서혜부 스트레치(Groin stretch, lotus)",
            "thumb": "/assets/thumbs/Stretch-0047.png",
            "guide": [
                "발바닥을 붙이고 앉아 무릎을 양 옆으로 벌린다.",
                "팔꿈치로 다리를 누르거나 상체를 앞으로 숙여 15초 유지하고, 3세트 반복한다."
            ]
        },
    ],
    "thigh_biceps_femoris": [
        {
            "id": "FR/FR-0014",
            "title": "대퇴이두근 자가근막이완-폼롤러(Biceps Femoris Self Myofascial Release-foam roller)",
            "thumb": "/assets/thumbs/FR-0014.png",
            "guide": [
                "대퇴부 안쪽에 폼롤러를 가로로 두고 앉아 엉덩이를 들고 30초~1분 내외로 폼롤러를 위아래로 굴린다.(3~5회 반복)"
            ]
        },
        {
            "id": "TP/TP-0096",
            "title": "슬굴곡근 자가근막이완-공(Hamstring self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0096.png",
            "guide": [
                "엉덩이 아래쪽과 오금 중간 허벅지 밑에 마사지공을 두고 앉는다.",
                "엉덩이를 들어 체중을 실어 마사지볼을 위아래로 30초~1분간 굴려 슬굴곡근을 압박이완(마시지) 한다.",
                "같은 방법으로 반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0058",
            "title": "대퇴이두근 스트레치(Biceps Femoris stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0058.png",
            "guide": [
                "바로 누워 한쪽 다리를 펴서 들어올린 후 안쪽 45° 방향으로 끌어당겨 15초간 유지한다.",
                "양쪽 모두 실시하고 3회씩 반복한다."
            ]
        },
    ],
    "thigh_medial_hamstrings": [
        {
            "id": "Static/Static-F-0177",
            "title": "햄스트링 자가근막이완-폼롤러(Hamstring Self Myofascial release, foam roller)",
            "thumb": "/assets/thumbs/Static-F-0177.png",
            "guide": [
                "허벅지 뒤쪽에 폼롤러를 가로로 두고 앚아 다리를 뻗고 엉덩이를 든다.",
                "팔로 지지하여 폼롤러를 굴리듯이 위아래로 움직여 30초~1분 내외로 햄스트링을 압박이완 한다.(3~5회 반복)"
            ]
        },
        {
            "id": "TP/TP-0096",
            "title": "슬굴곡근 자가근막이완-공(Hamstring self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0096.png",
            "guide": [
                "엉덩이 아래쪽과 오금 중간 허벅지 밑에 마사지공을 두고 앉는다.",
                "엉덩이를 들어 체중을 실어 마사지볼을 위아래로 30초~1분간 굴려 슬굴곡근을 압박이완(마시지) 한다.",
                "같은 방법으로 반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0055",
            "title": "햄스트링 스트레치-누워서(Hamstring stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0055.png",
            "guide": [
                "다리 펴고 누워 양 손으로 한 쪽 다리의 허벅지를 잡아 몸쪽으로 끌어당기고 15초 유지한다.",
                "양쪽 다리를 번갈아 가며 3회씩 반복한다."
            ]
        },
    ],
    "thigh_hip_flexors": [
        {
            "id": "FR/FR-0010",
            "title": "고관절 굴곡근 자가근막이완-폼롤러(Hip Flexor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0010.png",
            "guide": [
                "골반 밑(고관절 굴곡근)에 폼롤러를 두고 엎드린다.",
                "다리를 펴서 30초~1분간  폼롤러를 굴려 고관절 굴곡근을 압박이완 한다.",
                "3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0041",
            "title": "고관절 굴곡근 스트레치(Hip Flexor stretch)",
            "thumb": "/assets/thumbs/Stretch-0041.png",
            "guide": [
                "무릎을 굽혀 오른쪽 다리를 뒤로 보내고, 왼쪽 발을 앞으로 보내 바닥을 밟는다.",
                "오른팔을 위로 뻗어 상체와 함께 왼쪽으로 측굴 후 몸통을 오른쪽으로 회전하고 골반을 뒤로 기울인다.(후방전위)",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0015",
            "title": "내전근 자가근막이완-폼롤러(Adductor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0015.png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 두고 엎드린다.",
                "폼롤러에 체중을 싣고 30초~1분간 좌우로 굴려 내전근을 압박이완한다.",
                "반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0113(Adductor longus)",
            "title": "장내전근 자가근막이완-공(Hip Adductor self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0113(adductor longus).mp4_000007807.png",
            "guide": [
                "옆으로 누워 위 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 세로로 둔다.",
                "폼롤러에 올린 다리의 서혜부와 폼롤러 사이에 마사지공을 두고 체중을 실어 30초~1분간 압박한다.",
                "3~5세트 반복하고, 반대쪽으로도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0047",
            "title": "장내전근 스트레치(Hip Adductor stretch)",
            "thumb": "/assets/thumbs/Stretch-0047.png",
            "guide": [
                "발바닥을 붙이고 앉아 무릎을 양 옆으로 벌린다.",
                "팔꿈치로 다리를 누르거나 상체를 앞으로 숙여 15초 유지하고, 3세트 반복한다."
            ]
        },
    ],
    "thigh_hip_adductor_complex": [
        {
            "id": "FR/FR-0015(pectineus)",
            "title": "치골근 자가근막이완-폼롤러(Pectineus self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0015(pectineus).png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 두고 체중을 싣고 엎드린다.",
                "30초~1분간 폼롤러를 좌우로 굴려 3~5세트 반복하고, 같은 방법으로 반대쪽도 실시한다."
            ]
        },
        {
            "id": "TP/TP-0092",
            "title": "치골근 자가근막이완-공(Pectineus self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0092.png",
            "guide": [
                "옆으로 누워 위 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 세로로 둔다.",
                "폼롤러에 올린 다리의 서혜부와 폼롤러 사이에 마사지공을 두고 체중을 실어 30초~1분간 압박한다.",
                "3~5세트 반복하고, 같은 방법으로 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0047",
            "title": "서혜부 스트레치(Groin stretch, lotus)",
            "thumb": "/assets/thumbs/Stretch-0047.png",
            "guide": [
                "발바닥을 붙이고 앉아 무릎을 양 옆으로 벌린다.",
                "팔꿈치로 다리를 누르거나 상체를 앞으로 숙여 15초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0015",
            "title": "내전근 자가근막이완-폼롤러(Adductor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0015.png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 두고 엎드린다.",
                "폼롤러에 체중을 싣고 30초~1분간 좌우로 굴려 내전근을 압박이완한다.",
                "반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0113(Adductor longus)",
            "title": "장내전근 자가근막이완-공(Hip Adductor self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0113(adductor longus).mp4_000007807.png",
            "guide": [
                "옆으로 누워 위 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 세로로 둔다.",
                "폼롤러에 올린 다리의 서혜부와 폼롤러 사이에 마사지공을 두고 체중을 실어 30초~1분간 압박한다.",
                "3~5세트 반복하고, 반대쪽으로도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0047",
            "title": "장내전근 스트레치(Hip Adductor stretch)",
            "thumb": "/assets/thumbs/Stretch-0047.png",
            "guide": [
                "발바닥을 붙이고 앉아 무릎을 양 옆으로 벌린다.",
                "팔꿈치로 다리를 누르거나 상체를 앞으로 숙여 15초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0015",
            "title": "고관절 내전근 자가근막이완-폼롤러(Hip Adductor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0015.png",
            "guide": [
                "앞으로 엎드려 폼롤러를 안쪽 내전근에 놓고 체중을 이용하여 압박한다. 30초 3회 반복한다."
            ]
        },
        {
            "id": "TP/TP-0110",
            "title": "대내전근 자가근막이완-공(Adductor Magnus self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0110.png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 마사지공을 대고 엎드린다.",
                "마사지공에 체중을 실어 30초~1분 내외로 압박이완 한다.",
                "같은 방법으로 반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0043",
            "title": "고관절 내전근 스트레치(Hip Adductor stretch)",
            "thumb": "/assets/thumbs/Stretch-0043.png",
            "guide": [
                "다리를 넓게 벌리고 서서 오른발을 바깥쪽으로 회전한다.(고관절 외전, 외회전)",
                "왼쪽 무릎을 굽히고 앉으면서 체중을 실어 15초간 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0045",
            "title": "내전근 스트레치-스텝박스(Adductor stretch, step)",
            "thumb": "/assets/thumbs/Stretch-0045.png",
            "guide": [
                "스텝박스를 옆으로 두고 선다.",
                "한 발을 스텝박스에 올리고, 반대쪽 다리는 옆으로 뻗어 발을 바깥쪽으로 회전한다.",
                "스텝박스에 올린 다리의 무릎을 굽히고 상체를 옆으로 뻗은 다리쪽으로 숙여 15초 유지한다.",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
    ],
    "thigh_hip_internal_rotators": [
        {
            "id": "FR/FR-0015",
            "title": "내전근 자가근막이완-폼롤러(Adductor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0015.png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 두고 엎드린다.",
                "폼롤러에 체중을 싣고 30초~1분간 좌우로 굴려 내전근을 압박이완한다.",
                "반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0113(Adductor longus)",
            "title": "장내전근 자가근막이완-공(Hip Adductor self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0113(adductor longus).mp4_000007807.png",
            "guide": [
                "옆으로 누워 위 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 세로로 둔다.",
                "폼롤러에 올린 다리의 서혜부와 폼롤러 사이에 마사지공을 두고 체중을 실어 30초~1분간 압박한다.",
                "3~5세트 반복하고, 반대쪽으로도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0047",
            "title": "장내전근 스트레치(Hip Adductor stretch)",
            "thumb": "/assets/thumbs/Stretch-0047.png",
            "guide": [
                "발바닥을 붙이고 앉아 무릎을 양 옆으로 벌린다.",
                "팔꿈치로 다리를 누르거나 상체를 앞으로 숙여 15초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0015",
            "title": "고관절 내전근 자가근막이완-폼롤러(Hip Adductor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0015.png",
            "guide": [
                "앞으로 엎드려 폼롤러를 안쪽 내전근에 놓고 체중을 이용하여 압박한다. 30초 3회 반복한다."
            ]
        },
        {
            "id": "TP/TP-0110",
            "title": "대내전근 자가근막이완-공(Adductor Magnus self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0110.png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 마사지공을 대고 엎드린다.",
                "마사지공에 체중을 실어 30초~1분 내외로 압박이완 한다.",
                "같은 방법으로 반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0043",
            "title": "고관절 내전근 스트레치(Hip Adductor stretch)",
            "thumb": "/assets/thumbs/Stretch-0043.png",
            "guide": [
                "다리를 넓게 벌리고 서서 오른발을 바깥쪽으로 회전한다.(고관절 외전, 외회전)",
                "왼쪽 무릎을 굽히고 앉으면서 체중을 실어 15초간 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0031",
            "title": "복부 스트레치-짐볼(Abdominal stretch, Stability ball)",
            "thumb": "/assets/thumbs/Stretch-0031.png",
            "guide": [
                "짐볼 위에 등을 대고 누워 팔을 위로 뻗고 15초간 유지한다.(3회 반복)"
            ]
        },
    ],
    "thigh_hip_external_rotators": [
        {
            "id": "FR/FR-0018",
            "title": "이상근 자가근막이완-폼롤러(Piriformis Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0018.png",
            "guide": [
                "팔을 뒤로 보내 바닥을 짚고 폼롤러 위에 앉아 한 쪽 다리를 반대쪽 무릎 위에 올린다.",
                "올린 다리의 엉덩이 아래쪽 이상근을 압박하면서 30초~1분 내외로 폼롤러를 굴린다.",
                "3~5회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "TP/TP-0088",
            "title": "이상근 자가근막이완-공(Piriformis self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0088.png",
            "guide": [
                "무릎을 세우고 팔을 뒤로 보내 바닥을 짚고 앉는다.",
                "한 쪽 발목을 반대쪽 무릎 위에 올리고 바닥에 있는 다리의 엉덩이 밑에 마사지볼을 둔다.",
                "마사지볼에 체중을 실어 이상근을 압박하여 30초~1분간 유지한다.",
                "같은 방법으로 반대쪽으로 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0038",
            "title": "이상근 스트레치-짐볼(Piriformis stretch, Stability Ball)",
            "thumb": "/assets/thumbs/Stretch-0038.png",
            "guide": [
                "다리를 짐볼 위에 올린다. 한 쪽 다리를 굽혀 반대쪽 무릎 위에 올린다.",
                "짐볼 위 다리의 무릎 뒤(슬와부)를 깎지를 껴서 다리를 가슴 쪽으로 당긴다.",
                "15초간 유지하여 3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0039",
            "title": "이상근 스트레치-누워서(Piriformis stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0039.png",
            "guide": [
                "무릎을 굽히고 바로 누워 한 쪽 다리를 반대쪽 무릎 위에 올린다.",
                "바닥에 둔 다리의 무릎 뒤(슬와부)로 깎지를 껴서 다리를 가슴쪽으로 당긴다.",
                "15초간 유지하여 3회 반복하고 반대쪽도 실시한다."
            ]
        },
    ],
    "thigh_iliopsoas": [
        {
            "id": "FR/FR-0010",
            "title": "고관절 굴곡근 자가근막이완-폼롤러(Hip Flexor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0010.png",
            "guide": [
                "골반 밑(고관절 굴곡근)에 폼롤러를 두고 엎드린다.",
                "다리를 펴서 30초~1분간  폼롤러를 굴려 고관절 굴곡근을 압박이완 한다.",
                "3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0041",
            "title": "고관절 굴곡근 스트레치(Hip Flexor stretch)",
            "thumb": "/assets/thumbs/Stretch-0041.png",
            "guide": [
                "무릎을 굽혀 오른쪽 다리를 뒤로 보내고, 왼쪽 발을 앞으로 보내 바닥을 밟는다.",
                "오른팔을 위로 뻗어 상체와 함께 왼쪽으로 측굴 후 몸통을 오른쪽으로 회전하고 골반을 뒤로 기울인다.(후방전위)",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0015",
            "title": "내전근 자가근막이완-폼롤러(Adductor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0015.png",
            "guide": [
                "한 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 두고 엎드린다.",
                "폼롤러에 체중을 싣고 30초~1분간 좌우로 굴려 내전근을 압박이완한다.",
                "반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0113(Adductor longus)",
            "title": "장내전근 자가근막이완-공(Hip Adductor self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0113(adductor longus).mp4_000007807.png",
            "guide": [
                "옆으로 누워 위 쪽 무릎을 굽혀 허벅지 안쪽에 폼롤러를 세로로 둔다.",
                "폼롤러에 올린 다리의 서혜부와 폼롤러 사이에 마사지공을 두고 체중을 실어 30초~1분간 압박한다.",
                "3~5세트 반복하고, 반대쪽으로도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0047",
            "title": "장내전근 스트레치(Hip Adductor stretch)",
            "thumb": "/assets/thumbs/Stretch-0047.png",
            "guide": [
                "발바닥을 붙이고 앉아 무릎을 양 옆으로 벌린다.",
                "팔꿈치로 다리를 누르거나 상체를 앞으로 숙여 15초 유지하고, 3세트 반복한다."
            ]
        },
    ],


    "lower_leg_soleus": [
        {
            "id": "FR/FR-0019",
            "title": "외측 비복근, 가자미근 자가근막이완-폼롤러(Lateral Gastrocnemius Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0019.png",
            "guide": [
                "양쪽 다리를 뻗어 포개고 종아리 바깥쪽(외측 비복근) 아래에 폼롤러를 둔다.",
                "엉덩이를 들어 체중을 싣고 30초~1분간 폼롤러를 위아래로 굴린다.",
                "3~5회 반복하고 다리를 바꿔 실시한다."
            ]
        },
        {
            "id": "TP/TP-0149",
            "title": "가자미근 자가근막이완-공(Soleus self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0149.png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 다리를 반대쪽 다리 위로 올린다.",
                "10cm높이의 받침대 위에 마사지볼을 두고 볼 위에 종아리를 올린다.",
                "공을 가볍게 압박하면서 30초간 굴려준 후 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0063",
            "title": "가자미근 스트레치-앉아서(Soleus stretch, sitting)",
            "thumb": "/assets/thumbs/Stretch-0063.png",
            "guide": [
                "무릎을 구부리고 앉아 스트레치 하려는 다리를 90°로 굽혀 앞으로 보낸다.",
                "뒤꿈치를 바닥에 붙인 채 앞으로 보낸 다리의 무릎을 최대한 앞쪽으로 밀어낸다.",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0062",
            "title": "가자미근 스트레치(Soleus stretch)",
            "thumb": "/assets/thumbs/Stretch-0062.png",
            "guide": [
                "손으로 벽을 짚거나 Bar를 잡고 선다.",
                "스트레치 하고자 하는 다리를 뒤로 보내 뒤꿈치를 붙인 상태에서 무릎을 최대한 굽혀 가자미근을 스트레치한다.",
                "15초간 유지하여 3회 반복하고 반대쪽도 실시한다."
            ]
        },
    ],
    "lower_leg_peroneus": [
        {
            "id": "FR/FR-0020",
            "title": "비골근 자가근막이완-폼롤러(Peroneus Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0020.png",
            "guide": [
                "옆으로 누워 종아리 바깥쪽을 폼롤러에 올리고 종아리 마사지 하 듯이 근육을 압박 이완시킨다. 1분씩 3번반복한다"
            ]
        },
        {
            "id": "TP/TP-0101",
            "title": "비골근 자가근막이완-공(Peroneal Muscles self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0101.png",
            "guide": [
                "옆으로 누워 무릎아래 정강뼈 옆쪽 근육(비골근)에 마자지볼을 둔다.",
                "마사지볼을 압박하면서 30초~1분간 굴려 비골근을 마사지한다.",
                "반대쪽도 같은 방법으로 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0102",
            "title": "봉을 이용한 비골근 근육이완(Peroneal Muscles self myofascial release, stick)",
            "thumb": "/assets/thumbs/TP-0102.png",
            "guide": [
                "옆으로 앉아 무릎아래 정강뼈 옆쪽 근육(비골근)을 마사지 봉으로 압박하면서 위아래쪽으로 풀어준다.",
                "30초~1분간 지속 후 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
    ],

    "lower_leg_gastrocnemius": [
        {
            "id": "FR/FR-0019",
            "title": "비복근 자가근막이완-폼롤러(Gastrocnemius Self Myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0019.png",
            "guide": [
                "폼롤러 위에 한발의 종아리를 올리고 다른 다리를 겹쳐 위에 두고 비복근을 압박 이완한다. 30초~1분내외 3회반복한다. 양쪽모두 수행한다."
            ]
        },
        {
            "id": "TP/TP-0100",
            "title": "비복근 자가근막이완-공(Gastrocnemius self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0100.png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 다리를 반대쪽 다리 위로 올린다.",
                "10cm높이의 받침대 위에 마사지볼을 두고 볼 위에 종아리를 올린다.",
                "공을 가볍게 압박하면서 30초간 굴려준 후 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0061",
            "title": "비복근 스트레치(Gastrocnemius stretch)",
            "thumb": "/assets/thumbs/Stretch-0061.png",
            "guide": [
                "벽에 양 손을 짚고 기대어 선다.",
                "한 발을 앞으로 보내 무릎을 구부리고, 뒤쪽 다리는 무릎을 펴고 뒤꿈치를 바닥에 붙여 15초간 유지한다.",
                "양쪽 모두 실시하고, 3회 반복한다."
            ]
        },
    ],

    "lower_leg_fdl": [
        {
            "id": "FR/FR-0019(flexor digitorum longus)",
            "title": "장지굴근 자가근막이완-폼롤러(flexor digitorum self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0019(flexor digitorum longus).png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 다리를 반대쪽 다리 위로 올리고 아래쪽 종아리 밑에 폼롤러를 둔다.",
                "엉덩이를 들어 체중을 싣고 30초~1분간 폼롤러를 위아래로 굴려 장지굴근을 압박이완(마사지) 한다.",
                "반대쪽도 같은 방법으로 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0165",
            "title": "장지굴근 자가근막이완-공(flexor digitorum self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0165.png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 다리를 반대쪽 다리 위로 올린다.",
                "10cm높이의 받침대 위에 마사지볼을 두고 볼 위에 종아리를 올린다.",
                "공을 가볍게 압박하면서 30초간 굴려준 후 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0061(flexor digitorum longus)",
            "title": "장지굴근 스트레치(flexor digitorum stretch)",
            "thumb": "/assets/thumbs/Stretch-0061(flexor digitorum longus).png",
            "guide": [
                "양 다리를 펴고 앉아 한 쪽 발에 수건을 걸어 양 끝을 손으로 잡는다.",
                "수건을 몸쪽으로 당겨(족배굴곡) 15초간 유지한다.",
                "같은 방법으로 발을 바꿔 실시하고, 3세트 반복한다."
            ]
        },
    ],

    "lower_leg_edl": [
        {
            "id": "FR/FR-0021(extensor digitorum lognus)",
            "title": "장지신근 자가근막이완-폼롤러(Extensor Digitorum self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0021(extensor digitorum lognus).png",
            "guide": [
                "네 발 기기 자세로 엎드려 무릎 아래 정가이뼈(경골) 밑에 폼롤러를 가로로 둔다.",
                "폼롤러를 위아래로 굴려 앞 정강이 근육(장지신근)을 압박이완(마사지) 한다.",
                "30초간 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0146",
            "title": "장지신근 자가근막이완-공(Extensor Digitorum self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0146.png",
            "guide": [
                "네 발 기기 자세로 엎드려 한 쪽 무릎 아래 정가이뼈(경골) 밑에 마사지볼을 둔다.",
                "마사지볼에 가볍게 체중을 실어 위아래로 굴려 앞 정강이 근육(장지신근)을 압박이완(마사지) 한다.",
                "30초간 유지 후 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0079",
            "title": "장지신근 스트레치(Extensor Digitorum stretch)",
            "thumb": "/assets/thumbs/Stretch-0079.png",
            "guide": [
                "한 쪽 발가락 끝을 바닥에 두고 신전하여 15초간 유지한다.",
                "발을 바꿔 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
    ],

    "lower_leg_tib_ant": [
        {
            "id": "FR/FR-0021",
            "title": "전경골근 자가근막이완-폼롤러(Anterior Shin, Foam Roller)",
            "thumb": "/assets/thumbs/FR-0021.png",
            "guide": [
                "무릎 아래 정강이뼈(경골)에 폼롤러를 가로로 두고 푸쉬업 자세로 엎드린다.",
                "폼롤러를 위 아래쪽으로 굴려 앞정강이 근육(전경골근)을 압박이완 한다.",
                "30초~1분간 반복하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0146(anterior tibialis)",
            "title": "전경골근 자가근막이완-공(Anterior tibialis self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0146(anterior tibialis).png",
            "guide": [
                "네 발 기기 자세로 엎드려 한 쪽 무릎 아래 정가이뼈(경골) 밑에 마사지볼을 둔다.",
                "마사지볼에 가볍게 체중을 실어 위아래로 굴려 앞 정강이 근육(전경골근)을 압박이완(마사지) 한다.",
                "30초간 유지 후 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0080",
            "title": "전경골근 스트레치(Anterior tibialis stretch)",
            "thumb": "/assets/thumbs/Stretch-0080.png",
            "guide": [
                "스트레치 하려는 다리를 뒤로 보내고 무릎을 세워 앉는다.",
                "뒤쪽 다리의 발을 안쪽 45° 방향으로 보내 발등을 펴서 바닥에 대고 천천히 엉덩이를 내려 전경골근을 스트레치한다.",
                "10~15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
    ],

    "lower_leg_plantaris": [
        {
            "id": "FR/FR-0024(plantaris)",
            "title": "족척근 자가근막이완-폼롤러(Plantaris self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0024(plantaris).png",
            "guide": [
                "다리를 펴서 무릎 뒤쪽 오금에 폼롤러를 두고 앉아 한 쪽 다리를 반대쪽 다리 위로 올린다.",
                "엉덩이를 들어 체중을 싣고 30초~1분간 폼롤러를 위아래로 굴려 족척근을 압박이완 한다.",
                "같은 방법으로 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0140",
            "title": "족척근 자가근막이완-공(Plantaris self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0140.png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 무릎 뒤쪽 오금에 마사지볼을 둔다.",
                "엉덩이를 가볍게 들어 체중을 싣고 30초~1분간 마사지볼을 위아래로 굴려 족척근을 압박이완한다.",
                "같은 방법으로 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0063(plantaris)",
            "title": "족척근 스트레치(Plantaris stretch)",
            "thumb": "/assets/thumbs/Stretch-0063(plantaris).png",
            "guide": [
                "무릎을 굽혀 세우고 앉아 스트레치 하려는 다리를 앞으로 보낸다.",
                "앞으로 보낸 다리의 뒤꿈치를 바닥에 붙인 채 무릎을 최대한 굽혀 15초간 유지한다.",
                "같은 방법으로 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
    ],

    "lower_leg_tib_post": [
        {
            "id": "FR/FR-0019(posterior tibialis)",
            "title": "후경골근 자가근막이완-폼롤러(Tibialis Posterior self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0019(posterior tibialis).png",
            "guide": [
                "다리를 펴서 종아리 밑에 폼롤러를 가로로 두고 앉아 한 쪽 다리를 반대쪽 다리 위에 올린다.",
                "엉덩이를 들어 체중을 실어 30초~1분간 폼롤러를 위아래로 굴린다.",
                "같은 방법으로 다리를 바꿔 실시하고, 3~5세트 반복한다"
            ]
        },
        {
            "id": "TP/TP-0103",
            "title": "후경골근 자가근막이완-공(Tibialis Posterior self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0103.png",
            "guide": [
                "마자지볼을 종아리 안 뒤쪽(후경골근)에 둔다.",
                "손바닥으로 마사지볼을 가볍게 누르면서 30초~1분간 후경골근을 압박이완(마사지) 한다.",
                "같은 방법으로 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0064(posterior tibialis)",
            "title": "후경골근 스트레치(Tibialis Posterior stretch)",
            "thumb": "/assets/thumbs/Stretch-0064(posterior tibialis).png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 발에 수건을 걸고 양 끝을 손으로 잡는다.",
                "수건을 몸쪽으로 당기고(족배굴국 & 외반) 15초간 유지한다.",
                "발을 바꿔 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
    ],

    "lower_leg_gastro_lat": [
        {
            "id": "FR/FR-0019",
            "title": "외측 비복근 자가근막이완-폼롤러(Lateral Gastrocnemius Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0019.png",
            "guide": [
                "양쪽 다리를 뻗어 포개고 종아리 살짝 바깥쪽(외측 비복근) 아래에 폼롤러를 둔다.",
                "엉덩이를 들어 체중을 실으며 30초~1분간 폼롤러를 굴린다.",
                "3~5회 반복하고 다리를 바꿔 실시한다."
            ]
        },
        {
            "id": "TP/TP-0100",
            "title": "비복근 자가근막이완-공(Gastrocnemius self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0100.png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 다리를 반대쪽 다리 위로 올린다.",
                "10cm높이의 받침대 위에 마사지볼을 두고 볼 위에 종아리를 올린다.",
                "공을 가볍게 압박하면서 30초간 굴려준 후 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0061",
            "title": "비복근 스트레치(Gastrocnemius stretch)",
            "thumb": "/assets/thumbs/Stretch-0061.png",
            "guide": [
                "벽에 양 손을 짚고 기대어 선다.",
                "한 발을 앞으로 보내 무릎을 구부리고, 뒤쪽 다리는 무릎을 펴고 뒤꿈치를 바닥에 붙여 15초간 유지한다.",
                "양쪽 모두 실시하고, 3회 반복한다."
            ]
        },
    ],

    "lower_leg_gastro_med": [
        {
            "id": "FR/FR-0019",
            "title": "비복근 자가근막이완-폼롤러(Gastrocnemius Self Myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0019.png",
            "guide": [
                "폼롤러 위에 한발의 종아리를 올리고 다른 다리를 겹쳐 위에 두고 비복근을 압박 이완한다. 30초~1분내외 3회반복한다. 양쪽모두 수행한다."
            ]
        },
        {
            "id": "TP/TP-0100",
            "title": "비복근 자가근막이완-공(Gastrocnemius self myofascial release, ball)",
            "thumb": "/assets/thumbs/TP-0100.png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 다리를 반대쪽 다리 위로 올린다.",
                "10cm높이의 받침대 위에 마사지볼을 두고 볼 위에 종아리를 올린다.",
                "공을 가볍게 압박하면서 30초간 굴려준 후 다리를 바꿔 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0061",
            "title": "비복근 스트레치(Gastrocnemius stretch)",
            "thumb": "/assets/thumbs/Stretch-0061.png",
            "guide": [
                "벽에 양 손을 짚고 기대어 선다.",
                "한 발을 앞으로 보내 무릎을 구부리고, 뒤쪽 다리는 무릎을 펴고 뒤꿈치를 바닥에 붙여 15초간 유지한다.",
                "양쪽 모두 실시하고, 3회 반복한다."
            ]
        },
    ],
};


export const TITLES = {

    // 목 세부 근육
    neck_scalene: "목갈비근(사각근)",
    neck_levator: "어깨올림근(견갑거근)",
    neck_subscap: "어깨밑근(견갑하근)",
    neck_cervical: "목널판근(경판상근)",
    neck_trap: "등세모근(승모근)",
    neck_suboccip: "뒤통수밑근(후두하근)",
    neck_scm: "목빗근(흉쇄유돌근)",
    neck_semispinalis: "목반가시근(경반극근)",
    neck_splenius: "머리널판근(두판상근)",
    neck_trap_lower: "아래등세모근(하승모근)",
    neck_trap_upper: "위등세모근(상승모근)",
    neck_longus: "긴목근육(경장근)",
    neck_multifidus: "목뭇갈래근(경추다열근)",
    neck_trap_middle: "중간등세모근(중부승모근)",

    // 어깨 세부 근육
    shoulder_supraspinatus: "가시위근(극상근)",
    shoulder_infraspinatus: "가시아래근(극하근)",
    shoulder_teres_major: "큰원근(대원근)",
    shoulder_deltoid: "어깨세모근(삼각근)",
    shoulder_teres_minor: "어깨작은원근(소원근)",
    shoulder_rotator_cuff: "회전근개(어깨돌림근띠)",

    // 팔 세부 근육
    arm_brachialis: "위팔근(상완근)",
    arm_triceps: "위팔세갈래근(상완삼두근)",
    arm_brachioradialis: "위팔노근(상완요골근)",
    arm_biceps: "위팔두갈래근(상완이두근)",
    arm_flexor: "손목굽힘근(수지굴근)",
    arm_pronator_teres: "원엎침근(원회내근)",
    arm_palmaris_longus: "긴손바닥근(장장근)",
    arm_supinator: "뒤침근(회외근)",
    arm_coracobrachialis: "부리상완근(오훼상완근)",

    // 복부 / 허리 세부 근육
    abdomen_rectus: "배곧은근(복직근)",
    lumbar_quadratus: "허리네모근(요방형근)",
    lumbar_psoas_major: "큰허리근(장요근)",
    lumbar_erector: "척추세움근(척추기립근)",
    abdomen_rectus_appendix: "복직근(맹장염)",
    lumbar_multifidus: "요추다열근(천장관절기능부전)",
    lumbar_quadratus_sij: "요방형근(천장관절기능부전)",
    abdomen_external_oblique: "외복사근(배바깥빗근)",
    abdomen_rectus_lower: "하부복직근(아래배곧은근)",
    abdomen_rectus_upper: "상부복직근(위배곧은근)",
    abdomen_internal_oblique: "내복사근(배속빗근)",
    core_stabilizer: "코어안정화 근육(Core Stabilizer)",


    // 상퇴(허벅지) 세부 근육
    thigh_vastus_medialis: "안쪽넓은근(내측광근)",
    thigh_adductor_magnus: "큰모음근(대내전근)",
    thigh_tfl: "넙다리근막긴장근(대퇴근막장근)",
    thigh_rectus_femoris: "넙다리곧은근(대퇴직근)",
    thigh_gracilis: "두덩정강근(박근)",
    thigh_sartorius: "넙다리빗근(봉공근)",
    thigh_hamstrings: "뒤넙다리근(슬굴곡근)",
    thigh_popliteus: "오금근(슬와근)",
    thigh_vastus_lateralis: "가쪽넓은근(외측광근)",
    thigh_adductor_longus: "긴모음근(장내전근)",
    thigh_vastus_intermedius: "중간넓은근(중간광근)",
    thigh_pectineus: "두덩근(치골근)",
    thigh_biceps_femoris: "넙다리두갈래근(대퇴이두근)",
    thigh_medial_hamstrings: "내출슬굴곡근(안쪽무릎굽힘근)",
    thigh_hip_flexors: "고관절 굴곡근(Hip Flexor Muscle)",
    thigh_hip_adductor_complex: "고관절 내전근군(Hip Adductor complex)",
    thigh_hip_internal_rotators: "고관절 내회근군(Hip internal rotator)",
    thigh_hip_external_rotators: "고관절 외회근군(Hip external rotator)",
    thigh_iliopsoas: "엉덩허리근(장요근)",

    //하퇴(종아리) 세부 근육
    lower_leg_soleus: "넙치근(가자미근)",
    lower_leg_peroneus: "종아리근(비골근)",
    lower_leg_gastrocnemius: "장딴지근(비복근)",
    lower_leg_fdl: "긴발가락굽힘근(장지굴근)",
    lower_leg_edl: "긴발가락폄근(장지신근)",
    lower_leg_tib_ant: "앞정강근(전경골근)",
    lower_leg_plantaris: "장딴지빗근(족척근)",
    lower_leg_tib_post: "뒤정강근(후경골근)",
    lower_leg_gastro_lat: "외측비복근(바깥장딴지근)",
    lower_leg_gastro_med: "내측비복근(안쪽장딴지근)",
};


export const TITLE_TO_KEY = Object.fromEntries(
    Object.entries(TITLES).map(([k, v]) => [v, k])
);

export const CATEGORY_OPTIONS = Object.entries(TITLES).map(([key, label]) => ({
    key,
    label,
}));
